module.exports = __webpack_public_path__ + "img/uid-token-bg-hen.ca40042f.png";